var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.69,153.66h74.24v-12.4H71.69Zm86.27,0h12.69v-12.4H158Zm-111.34,0H59.31v-12.4H46.62Zm6.13-24H65.44v-12.4H52.75Zm24.71,0H90.15v-12.4H77.46Zm24.72,0h12.69v-12.4H102.18Zm24.72,0h12.7v-12.4H126.9Zm24.72,0h12.7v-12.4h-12.7Zm-98.87-24H65.44V93.22H52.75Zm24.71,0H90.15V93.22H77.46Zm24.72,0h12.69V93.22H102.18Zm24.72,0h12.7V93.22H126.9Zm24.72,0h12.7V93.22h-12.7ZM35,163.24H182.29V79.15H35Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 108.92,
    y1: 78.36,
    x2: 108.92,
    y2: 40.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/KEYBOARD.93008e8f50569368d7c15ad90ad74929.svg";
export { ForwardRef as ReactComponent };